import { render, staticRenderFns } from "./Responseblity.vue?vue&type=template&id=4b4d31f8&scoped=true&"
import script from "./Responseblity.vue?vue&type=script&lang=js&"
export * from "./Responseblity.vue?vue&type=script&lang=js&"
import style0 from "./Responseblity.vue?vue&type=style&index=0&id=4b4d31f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4d31f8",
  null
  
)

export default component.exports